import React from "react";
import { Link } from "react-router-dom";
import "./ResetPass.css";
import Seo from "../../Seo/Seo";
import { useSiteSeo } from "../../../context/SiteSeoContext";
import { truncateMetaDescription } from "../../../utils/seoText";

const ResetPass = () => {
  const siteCtx = useSiteSeo();
  const titleSuffix =
    siteCtx.organization_name && String(siteCtx.organization_name).trim()
      ? ` | ${String(siteCtx.organization_name).trim()}`
      : " | Gem Fashion Studios";

  return (
    <>
      <Seo
        title={`Reset password${titleSuffix}`}
        description={truncateMetaDescription(
          "Reset your Gem Fashion Studios account password using the email we send."
        )}
        canonicalPath="/resetPassword"
        noindex
        noindexFollow
      />
      <div className="resetPasswordSection">
        <h2>Reset Your Password</h2>
        <div className="resetPasswordContainer">
          <p>We will send you an email to reset your password</p>
          <form>
            <input type="email" placeholder="Email address *" required />
            <button type="submit">Submit</button>
          </form>
        </div>
        <p>
          Back to{" "}
          <Link to="/loginSignUp">
            <span>Login</span>
          </Link>
        </p>
      </div>
    </>
  );
};

export default ResetPass;
